import { Form as FactorialForm } from 'factorial-form'
import { computed, makeObservable } from 'mobx'

import { PeriodScheduleType } from 'modules/work_schedules/lib/forms/PeriodScheduleTypeForm'

class WorkSchedulePeriodForm extends FactorialForm {
  constructor(values: object) {
    super(values, {
      id: 'string',
      start_date: 'date',
      end_date: 'date',
      schedule_type: 'string',
    })

    makeObservable(this, {
      isFixed: computed,
    })
  }

  get isFixed(): boolean {
    return this.get('schedule_type').value === PeriodScheduleType.fixed
  }
}

export default WorkSchedulePeriodForm
